import { AssistantOutlined } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Button } from '@mui/material';

import Typography from '@/components/Typography';
import { useChat } from '@/features/AIChat/context/useChat';

const Header = ({ onClick }: { onClick: (e: React.MouseEvent<HTMLDivElement>) => void }) => {
  const { conversationId, setConversationId, messages } = useChat();
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: '1px solid var(--GX-Text-Disabled, #6C737A)',
        background: 'var(--GX-Main-Background, #070818)'
      }}
    >
      <Box
        sx={{
          position: 'relative',
          left: '24px'
        }}
      >
        <Typography
          component='div'
          sx={{
            display: 'flex',
            gap: '16px',
            alignItems: 'center',
            fontSize: '32px',
            height: '60px'
          }}
          variant='h2'
        >
          <AssistantOutlined
            sx={{
              width: '32px',
              height: '32px'
            }}
          />
          GX Go Assistant
        </Typography>
        <Typography
          component='div'
          sx={{
            color: 'var(--GX-Text-Disabled, #6C737A)',
            fontFamily: 'Cairo',
            fontSize: '12px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: 'normal'
          }}
        >
          Chat initialized with thread ID:{' '}
          {conversationId ?? 'There was an error. Please try again'}
        </Typography>
      </Box>
      <Button
        color='primary'
        disabled={messages.length === 0 && conversationId !== null}
        size='large'
        sx={{
          '&.Mui-disabled': {
            backgroundColor: 'var(--GX-Text-Disabled, #6C737A)',
            color: 'var(--GX-Neutral, #4F5458)',
            opacity: 1
          },
          position: 'absolute',
          left: '445px',
          width: '144px',
          height: '36px',
          padding: '4px 12px'
        }}
        variant='contained'
        onClick={() => {
          setConversationId('');
        }}
      >
        <AddIcon
          sx={{
            width: '24px',
            height: '24px'
          }}
        />
        New Chat
      </Button>
      <Box
        role='button'
        sx={{
          width: 48,
          height: 130,
          backgroundColor: 'var(--GX-Tile-Dark, #0D1228)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          cursor: 'pointer'
        }}
        onClick={onClick}
      >
        <CloseIcon />
      </Box>
    </Box>
  );
};

export default Header;
